angular.module('gym.membership-plans').factory('MembershipPlans', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('membership_plans');
}]);
